import { contactInfo } from "../../data/content";
import useFormSubmit from "../../hooks/useFormSubmit";
import useReveal from "../../hooks/useReveal";
import { Field, TextareaField } from "../ui/Field";
import FormStatus from "../ui/FormStatus";
import SectionTitle from "../ui/SectionTitle";

export default function ContactMap() {
  const { status, errors, submit } = useFormSubmit();
  const formRef = useReveal();
  const mapRef = useReveal();

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(e.target);
  };

  return (
    <>
      <div ref={mapRef} className="reveal h-[420px] w-full sm:h-[500px]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d44538.574750406784!2d4.876322985385899!3d45.75794329642297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4ea516ae88797%3A0x408ab2ae4bb21f0!2z2YTZitmI2YY!5e0!3m2!1sar!2sfr!4v1764093195284!5m2!1sar!2sfr"
          title="Localisation de Sham Dabke à Lyon"
          className="h-full w-full"
          style={{ border: 0, filter: "grayscale(100%) invert(92%) contrast(83%)" }}
          loading="lazy"
          allowFullScreen
        />
      </div>

      <section id="contact" className="scroll-mt-20 bg-ink py-20 sm:py-28">
        <div className="container grid gap-14 lg:grid-cols-2">
          <div>
            <SectionTitle eyebrow="Contacts" title="Formulaire de contact général" />
            <p className="mb-8 text-stone-200">
              Pour toute question, collaboration, projet spécifique ou demande média, utilisez ce
              formulaire ou contactez-nous directement par téléphone ou email.
            </p>

            <dl className="divide-y divide-white/10 rounded-2xl bg-surface">
              <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">Téléphone</dt>
                <dd>
                  <a href={`tel:${contactInfo.phoneHref}`} className="text-white hover:text-gold-500">
                    {contactInfo.phone}
                  </a>
                </dd>
              </div>
              <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">E-mail</dt>
                <dd>
                  <a href={`mailto:${contactInfo.email}`} className="text-white hover:text-gold-500">
                    {contactInfo.email}
                  </a>
                </dd>
              </div>
              <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">
                  Localisation
                </dt>
                <dd className="text-white">{contactInfo.location}</dd>
              </div>
            </dl>
          </div>

          <div ref={formRef} className="reveal">
            <FormStatus
              status={status}
              errors={errors}
              successMessage="Votre message a bien été envoyé, nous vous répondrons dans les plus brefs délais."
            />
            <form onSubmit={handleSubmit} noValidate>
              <input type="hidden" name="form_type" value="contact" />
              <div className="grid gap-4 sm:grid-cols-2">
                <Field id="ct-nom" name="name" label="Nom complet" required />
                <Field id="ct-email" name="email" type="email" label="Email" required />
                <Field id="ct-sujet" name="subject" label="Sujet" className="sm:col-span-2" />
                <TextareaField id="ct-message" name="message" label="Votre message" className="sm:col-span-2" />
              </div>
              <button
                type="submit"
                disabled={status === "submitting"}
                className="btn-outline mt-6 w-full disabled:opacity-60"
              >
                {status === "submitting" ? "Envoi en cours…" : "Envoyer le message"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
